module.exports = __webpack_public_path__ + "static/media/meduEditor_selected.f24a4348.svg";